import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { addInteractableViewerObjectToUpright } from "../functions/interactiveUpright";
export default class InteractiveUprightSystem extends SystemBase {
    constructor(core) {
        super(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
        this.core = core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "InteractiveUprightSystem";
        this.mandatoryComponents = [COMPONENT_IDS.UPRIGHT_COMPONENT];
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const viewerObject = _newComponent.viewerObject;
        addInteractableViewerObjectToUpright(_entity, this.core, viewerObject);
    }
}
